	function transmissao(){
	return {
		"games":[
			{
				"informs":[
					{
						"text":"O vírus pode ser transmitido  de um indivíduo infectado para uma pessoa saudável, e também através das mãos e objetos contaminados.",
						"title":"Como se pega a doença",
						"image":"images/games/informs/transmissao/1.png",
					},
					{
						"text":"O indivíduo infectado ao tossir, espirrar ou falar, libera gotículas contaminadas. Estas gotículas, ao atingirem uma pessoa saudável, podem entrar pelos olhos, nariz ou boca, contaminando-a.",
						"title":"Como se pega a doença",
						"image":"images/games/informs/transmissao/1.png",
					},
					{
						"text":"Pessoas contaminadas que não apresentam sintomas transmitem o vírus tanto quanto as que apresentam os sintomas.",
						"title":"Como se pega a doença",
						"image":"images/games/informs/transmissao/1.png",
					},
					{
						"text":"Assim, é muito importante que todos sigam os métodos de prevenção, principalmente o uso da máscara e distanciamento.",
						"title":"Como se pega a doença",
						"image":"images/games/informs/transmissao/1.png",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/transmissao/1.png"
			}
		]
	};
}

export {transmissao};
